/**
 * Creates a object for every .Users DOM element.
 */
common.View.create('websiteForms::admin.CreateEdit', {

    onDOMLoad()
    {
        this.initDataset();
        this.reInitDataset();
    },

    initDataset()
    {
        this.element

            // Listen for type change.
            .find('select')
            .change(this.manageType)
            .end();
    },

    reInitDataset()
    {
        this.element.find('.canvas\\:\\:form-dataset-Index button[name="add"]')
            .on('click', this.initDataset.bind(this));
    },

    manageType(e)
    {
        // If type is email; add a placeholder to value field
        if ($(e.currentTarget).val() == 'email')
            $(e.currentTarget).parents('.dataset-item').find('input[name*="[value]"]').attr('placeholder', 'Vul iets in om mails te versturen naar dit email');

        else if ($(e.currentTarget).val() == 'select' || $(e.currentTarget).val() == 'radio' || $(e.currentTarget).val() == 'checkbox')
            $(e.currentTarget).parents('.dataset-item').find('input[name*="[value]"]').attr('placeholder', 'Vul hier de dropdown waardes in');

        else if ($(e.currentTarget).val() == 'submit')
            $(e.currentTarget).parents('.dataset-item').find('input[name*="[value]"]').attr('placeholder', 'Tekst in de knop');

        else
            $(e.currentTarget).parents('.dataset-item').find('input[name*="[value]"]').attr('placeholder', '');
    }


});
